import { Routes } from '@angular/router';
import { NotFoundPageComponent } from './Shared/components/not-found-page/not-found-page.component';
import { PrivacyComponent } from './Shared/pages/privacy/privacy.component';
import { TermsOfUseComponent } from './Shared/pages/terms-of-use/terms-of-use.component';
import { TermsOfServiceComponent } from './Shared/pages/terms-of-service/terms-of-service.component';
import { RedirectComponent } from './Shared/components/redirect/redirect.component';
import { TermsConditionsViewComponent } from './Shared/pages/terms-conditions-view/terms-conditions-view.component';
import { PublicLayoutComponent } from './app-modules/public-layout/public-layout.component';
import { seoResolverResolver } from './Core/_resolvers/seo-resolver.resolver';
import { PublicLayoutResolver } from './app-modules/public-layout/public-layout.resolver';
import { localeGuard } from './Core/locale/locale.guard';
import { LanguageLandingComponent } from './Core/locale/language-landing.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LanguageLandingComponent,
  },
  { path: 'platform/redirect', component: RedirectComponent },
  { path: 'redirect', component: RedirectComponent },
  // BXS-3627: there is deliberately NO `go/:token` route. The outbound click is
  // answered by the API, which logs it and 302s onward (§8.3) — an Angular route
  // could do neither, and in production Cloudflare rewrote `/go/…` to `/en/…`
  // before the request ever reached us.
  {
    path: ':locale/seller',
    canActivate: [localeGuard],
    loadChildren: () =>
      import('./app-modules/seller/seller.routes').then((r) => r.routes),
  },
  {
    path: ':locale',
    canActivate: [localeGuard],
    component: PublicLayoutComponent,
    resolve: {
      notifications: PublicLayoutResolver,
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./app-modules/public-layout/public-layout.routes').then(
            (r) => r.routes
          ),
      },

      {
        path: 'buyer',
        loadChildren: () =>
          import('./app-modules/buyer/buyer.routes').then((r) => r.routes),
      },

      {
        path: 'terms-and-conditions',
        component: TermsConditionsViewComponent, // Handles the case with is_private and user_type as query params
        resolve: { seo: seoResolverResolver },
        data: {
          title: 'Terms and Conditions | BidxSell',
          description:
            "Read BidxSell's complete terms and conditions for horse auctions. Understand bidding rules, payment terms, auction policies, and legal obligations.",
        },
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
        resolve: { seo: seoResolverResolver },
        data: {
          title: 'Privacy Policy - BidxSell Data Protection & Security',
          description:
            'Learn how BidxSell protects your privacy and handles your personal data. Our comprehensive privacy policy covers data collection, usage, storage, sharing practices, and your privacy rights under GDPR and other regulations.',
        },
      },
      {
        path: 'terms-of-use',
        component: TermsOfUseComponent,
        resolve: { seo: seoResolverResolver },
        data: {
          title: 'Terms of Use - BidxSell Platform Guidelines & Rules',
          description:
            "Review BidxSell's terms of use for our platform and services. Understand user responsibilities, acceptable use policies, platform guidelines, prohibited activities, and community standards.",
        },
      },
      {
        path: 'terms-of-service',
        component: TermsOfServiceComponent,
        resolve: { seo: seoResolverResolver },
        data: {
          title:
            'Terms of Service - BidxSell Legal Agreement & Service Conditions',
          description:
            'Comprehensive terms of service for BidxSell horse auction platform. Review service conditions, user obligations, legal agreements, liability terms, and dispute resolution procedures for our auction services.',
        },
      },
      {
        path: 'maintenance',
        loadComponent: () =>
          import(
            './app-modules/seller/seller-modules/auctions/pages/mainpage/mainpage.component'
          ).then((m) => m.MainpageComponent),
        resolve: { seo: seoResolverResolver },
        data: {
          title: 'Site Maintenance | BidxSell',
          description:
            "BidxSell is currently undergoing scheduled maintenance to improve your auction experience. We'll be back online shortly with enhanced features.",
        },
      },
    ],
  },
  { path: '**', component: NotFoundPageComponent },
];
